<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Price Guide
            </h1>
        </div>
        <div class="grid-container pad-top">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12">
                    <table class="price-guide-table">
                        <thead>
                            <tr>
                                <th class="col-one">&nbsp;</th>
                                <th>24-35</th>
                                <th>36-49</th>
                                <th>50-99</th>
                                <th>100-199</th>
                                <th>200-399</th>
                                <th>400-699</th>
                                <th>700-999</th>
                                <th>1000+</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="col-one">1 Colour</td>
                                <td>4.00</td>
                                <td>3.00</td>
                                <td>2.00</td>
                                <td>1.50</td>
                                <td>1.15</td>
                                <td>0.85</td>
                                <td>0.80</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">2 Colour</td>
                                <td>5.50</td>
                                <td>4.50</td>
                                <td>2.75</td>
                                <td>2.00</td>
                                <td>1.45</td>
                                <td>1.00</td>
                                <td>0.90</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">3 Colour</td>
                                <td>X</td>
                                <td>6.00</td>
                                <td>3.50</td>
                                <td>2.50</td>
                                <td>1.75</td>
                                <td>1.15</td>
                                <td>1.00</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">4 Colour</td>
                                <td>X</td>
                                <td>X</td>
                                <td>4.25</td>
                                <td>3.00</td>
                                <td>3.00</td>
                                <td>1.15</td>
                                <td>1.00</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">5 Colour</td>
                                <td>X</td>
                                <td>X</td>
                                <td>50-99</td>
                                <td>100-199</td>
                                <td>200-399</td>
                                <td>400-699</td>
                                <td>1.30</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">6 Colour</td>
                                <td>X</td>
                                <td>X</td>
                                <td>X</td>
                                <td>4.00</td>
                                <td>2.65</td>
                                <td>2.25</td>
                                <td>1.30</td>
                                <td>CALL</td>
                            </tr>
                            <tr>
                                <td class="col-one">7 Colour</td>
                                <td>X</td>
                                <td>X</td>
                                <td>X</td>
                                <td>4.50</td>
                                <td>2.95</td>
                                <td>2.15</td>
                                <td>1.40</td>
                                <td>CALL</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say</h5>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'PriceGuide',
    metaInfo() {
        return {
            title: 'Price guide',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Price guide' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/price-guide' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/PriceGuide.vue